import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IServicesOffering } from 'src/app/model/sitefinity/IServicesOffering';

@Component({
  selector: 'app-tech-services-email-modal',
  templateUrl: './tech-services-email-modal.component.html',
  styleUrls: ['./tech-services-email-modal.component.scss'],
})
export class TechServicesEmailModalComponent {
  @Input() modalWindowSettings: IServicesOffering;

  constructor(
    public dialogRef: MatDialogRef<TechServicesEmailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any
  ) { }

  closeModal() {
    this.dialogRef.close();
  }
}
